import { useQuery } from '@tanstack/react-query'
import { serverConfigQuery } from './query'

export const useServerConfig = () => {
  const { data } = useQuery(serverConfigQuery)
  return data
}
